export default {
  0: { label: 'Draft', color: 'grey' },
  1: { label: 'Submitted', color: 'primary' },
  2: { label: 'Approved', color: 'success' },
  3: { label: 'Rejected', color: 'red' }
};